import { Clear } from "@mui/icons-material";
import { Box } from "@mui/material";
import { AppContext } from "contexts/AppContext";
import { useContext } from "react";

export function FilterChip({label, onClear}){
  const { styleGuide } = useContext(AppContext)
  return (
    <Box display={'flex'} paddingX={'20px'} paddingY={'5px'} gap={1} borderRadius={'14px'} alignItems={'center'} sx={{backgroundColor: styleGuide.color3}}>
      <Box
        onClick={onClear}
        sx={{cursor: 'pointer', marginTop: '-1px'}}
      >
        <Clear fontSize="small" />
      </Box>
      <Box>
        <span style={{
          fontSize: styleGuide.contentSmallFontSize,
          color: styleGuide.color7,
          borderRadius: styleGuide.buttonBorderRadius,
          height: styleGuide.buttonMediumHeight,
          fontFamily: styleGuide.secondaryFontFamily,
          lineHeight: styleGuide.buttonMediumLineHeight,
        }}>
          {label}
        </span>
      </Box>
    </Box>
  )
}